export default "__VITE_ASSET__Bfsmzwl6__"